module.exports = __webpack_public_path__ + "static/media/external_icon_white.e336744a.svg";